import { useCallback, useEffect, useState } from 'react';

/** Match `DashboardPage.css` `@container dashboard-metric-card (max-width: 760px)`. */
export const METRIC_CARD_COMPACT_MAX_PX = 760;

/**
 * Tracks when the metric-card body region is narrow enough for stacked KPI chips + full-width chart.
 */
export function useMetricCardCompact(maxPx: number = METRIC_CARD_COMPACT_MAX_PX) {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const [compact, setCompact] = useState(false);

  const ref = useCallback((el: HTMLElement | null) => {
    setNode(el);
  }, []);

  useEffect(() => {
    if (!node) {
      return undefined;
    }

    const update = () => {
      const w = node.getBoundingClientRect().width;
      if (w <= 0) {
        return;
      }
      setCompact(w <= maxPx);
    };

    update();

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => {
        update();
      });
      ro.observe(node);
      return () => ro.disconnect();
    }

    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [node, maxPx]);

  return { ref, compact } as const;
}
